import { VueQuillEditor } from '@/plugins/Editor.ts'
import { flareVue } from '@/plugins/Flare.ts'
import { i18n } from '@/plugins/i18n'
import { MasonryWall } from '@/plugins/Masonry.ts'
import { pinia } from '@/plugins/pinia'
import queryClient from '@/plugins/queryClient'
import { tracewayVue } from '@/plugins/Traceway.ts'
import { GesturePlugin } from '@vueuse/gesture'
import type { App } from 'vue'

export function registerPlugins(app: App) {
	app.use(pinia)
	app.use(MasonryWall)
	app.use(VueQuillEditor)
	app.use(flareVue)
	if (tracewayVue) {
		app.use(tracewayVue)
	}
	app.use(i18n)
	app.use(queryClient)
	app.use(GesturePlugin)
}
